import { ContributorType } from "@/src/types";
import { Facebook, Instagram, Twitter } from "@mui/icons-material";
import Link from "next/link";
import React from "react";

const ContributorSocials = ({
  contributor,
}: {
  contributor: ContributorType;
}) => {
  return (
    <div className={"flex flex-row text-black"}>
      <Link
        href={contributor?.contributormeta?.facebookLink ?? ""}
        target="_blank"
        className={
          !contributor?.contributormeta?.facebookLink ||
          contributor?.contributormeta?.facebookLink === ""
            ? "hidden"
            : ""
        }
      >
        <Facebook />
      </Link>

      <Link
        href={contributor?.contributormeta?.twitterLink ?? ""}
        target="_blank"
        className={
          !contributor?.contributormeta?.twitterLink ||
          contributor?.contributormeta?.twitterLink === ""
            ? "hidden"
            : ""
        }
      >
        <Twitter />
      </Link>

      <Link
        href={contributor?.contributormeta?.instagramLink ?? ""}
        target="_blank"
        className={
          !contributor?.contributormeta?.instagramLink ||
          contributor?.contributormeta?.instagramLink === ""
            ? "hidden"
            : ""
        }
      >
        <Instagram />
      </Link>
    </div>
  );
};

export default ContributorSocials;
